import React, { FC, ReactElement } from "react";
import { Grid } from "@mui/material";
import { RetailContextProvider } from "../../contexts/retail/retailMain.context";
import {Redirect} from "../../utils/Redirect";
import {useRouter} from "../../utils/hooks/useRouter";

const Platform: FC<any> = (): ReactElement => {
  const router = useRouter()
  return (
    <Grid
      sx={{
        backgroundColor: "#fff",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        "@media (max-width: 600px)": {
          minHeight: "100vh",
          height: "auto",
        },
      }}
    >
      <Redirect to={`/retail/sso?code=${router.query.code}`}/>
      {/*<RetailContextProvider></RetailContextProvider>*/}
    </Grid>
  );
};

export default Platform;
